/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 保存质检改标配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/qualityLabelSetting`
 */
const postQualityLabelSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/qualityLabelSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postQualityLabelSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存质检改标配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/qualityLabelSetting`
 */
export const postQualityLabelSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postQualityLabelSettingRequestConfig, requestData),
    ...args
  );
};
postQualityLabelSetting.requestConfig = postQualityLabelSettingRequestConfig;
/**
 * 接口 保存质检规则配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/qualityRuleSettingSave`
 */
const postQualityRuleSettingSaveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/qualityRuleSettingSave",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postQualityRuleSettingSave",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存质检规则配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/qualityRuleSettingSave`
 */
export const postQualityRuleSettingSave = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postQualityRuleSettingSaveRequestConfig, requestData),
    ...args
  );
};
postQualityRuleSettingSave.requestConfig =
  postQualityRuleSettingSaveRequestConfig;
/**
 * 接口 导入高净值用户 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/importUserNetWorth`
 */
const postImportUserNetWorthRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/importUserNetWorth",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportUserNetWorth",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入高净值用户 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/importUserNetWorth`
 */
export const postImportUserNetWorth = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postImportUserNetWorthRequestConfig, requestData),
    ...args
  );
};
postImportUserNetWorth.requestConfig = postImportUserNetWorthRequestConfig;
/**
 * 接口 导出高净值用户数据 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `GET /erp/AdminSetting/exportUserNetWorth`
 */
const getExportUserNetWorthRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/exportUserNetWorth",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getExportUserNetWorth",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出高净值用户数据 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `GET /erp/AdminSetting/exportUserNetWorth`
 */
export const getExportUserNetWorth = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getExportUserNetWorthRequestConfig, requestData),
    ...args
  );
};
getExportUserNetWorth.requestConfig = getExportUserNetWorthRequestConfig;
/**
 * 接口 推送配置修改 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingSave`
 */
const postPushTaskSettingSaveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/pushTaskSettingSave",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPushTaskSettingSave",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 推送配置修改 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingSave`
 */
export const postPushTaskSettingSave = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postPushTaskSettingSaveRequestConfig, requestData),
    ...args
  );
};
postPushTaskSettingSave.requestConfig = postPushTaskSettingSaveRequestConfig;
/**
 * 接口 推送配置获取 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingGet`
 */
const postPushTaskSettingGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/pushTaskSettingGet",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPushTaskSettingGet",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 推送配置获取 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingGet`
 */
export const postPushTaskSettingGet = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postPushTaskSettingGetRequestConfig, requestData),
    ...args
  );
};
postPushTaskSettingGet.requestConfig = postPushTaskSettingGetRequestConfig;
/**
 * 接口 新客订单质检配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/newUserQualityRuleSettingSave`
 */
const postNewUserQualityRuleSettingSaveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/newUserQualityRuleSettingSave",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postNewUserQualityRuleSettingSave",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 新客订单质检配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/newUserQualityRuleSettingSave`
 */
export const postNewUserQualityRuleSettingSave = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postNewUserQualityRuleSettingSaveRequestConfig, requestData),
    ...args
  );
};
postNewUserQualityRuleSettingSave.requestConfig =
  postNewUserQualityRuleSettingSaveRequestConfig;
/**
 * 接口 精准质检-导入PC点货拦截质检配置:sku维度 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/importTallyAccurateSku`
 */
const postImportTallyAccurateSkuRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/importTallyAccurateSku",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportTallyAccurateSku",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-导入PC点货拦截质检配置:sku维度 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/importTallyAccurateSku`
 */
export const postImportTallyAccurateSku = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportTallyAccurateSkuRequestConfig, requestData),
    ...args
  );
};
postImportTallyAccurateSku.requestConfig =
  postImportTallyAccurateSkuRequestConfig;
/**
 * 接口 精准质检-导入PC质检拦截质检配置:sku维度 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/importQualityAccurateSku`
 */
const postImportQualityAccurateSkuRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/importQualityAccurateSku",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportQualityAccurateSku",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-导入PC质检拦截质检配置:sku维度 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/importQualityAccurateSku`
 */
export const postImportQualityAccurateSku = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportQualityAccurateSkuRequestConfig, requestData),
    ...args
  );
};
postImportQualityAccurateSku.requestConfig =
  postImportQualityAccurateSkuRequestConfig;
/**
 * 接口 精准质检-导出PC点货拦截质检配置:sku维度 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/exportTallyAccurateSku`
 */
const postExportTallyAccurateSkuRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/exportTallyAccurateSku",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportTallyAccurateSku",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-导出PC点货拦截质检配置:sku维度 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/exportTallyAccurateSku`
 */
export const postExportTallyAccurateSku = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportTallyAccurateSkuRequestConfig, requestData),
    ...args
  );
};
postExportTallyAccurateSku.requestConfig =
  postExportTallyAccurateSkuRequestConfig;
/**
 * 接口 精准质检-导出PC质检拦截质检配置:sku维度 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/exportQualityAccurateSku`
 */
const postExportQualityAccurateSkuRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/exportQualityAccurateSku",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportQualityAccurateSku",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-导出PC质检拦截质检配置:sku维度 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/exportQualityAccurateSku`
 */
export const postExportQualityAccurateSku = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportQualityAccurateSkuRequestConfig, requestData),
    ...args
  );
};
postExportQualityAccurateSku.requestConfig =
  postExportQualityAccurateSkuRequestConfig;
/**
 * 接口 精准质检-获取PC点货拦截质检配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/getTallyAccurate`
 */
const postGetTallyAccurateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/getTallyAccurate",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetTallyAccurate",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-获取PC点货拦截质检配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/getTallyAccurate`
 */
export const postGetTallyAccurate = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetTallyAccurateRequestConfig, requestData),
    ...args
  );
};
postGetTallyAccurate.requestConfig = postGetTallyAccurateRequestConfig;
/**
 * 接口 精准质检-获取PC质检拦截质检配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/getQualityAccurate`
 */
const postGetQualityAccurateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/getQualityAccurate",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetQualityAccurate",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-获取PC质检拦截质检配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/getQualityAccurate`
 */
export const postGetQualityAccurate = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetQualityAccurateRequestConfig, requestData),
    ...args
  );
};
postGetQualityAccurate.requestConfig = postGetQualityAccurateRequestConfig;
/**
 * 接口 精准质检-设置 PC质检-次品区-次品退换 配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/setQualityCpExchange`
 */
const postSetQualityCpExchangeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/setQualityCpExchange",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetQualityCpExchange",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-设置 PC质检-次品区-次品退换 配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/setQualityCpExchange`
 */
export const postSetQualityCpExchange = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetQualityCpExchangeRequestConfig, requestData),
    ...args
  );
};
postSetQualityCpExchange.requestConfig = postSetQualityCpExchangeRequestConfig;
/**
 * 接口 精准质检-设置PC点货拦截质检配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/setTallyAccurate`
 */
const postSetTallyAccurateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/setTallyAccurate",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetTallyAccurate",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-设置PC点货拦截质检配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/setTallyAccurate`
 */
export const postSetTallyAccurate = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetTallyAccurateRequestConfig, requestData),
    ...args
  );
};
postSetTallyAccurate.requestConfig = postSetTallyAccurateRequestConfig;
/**
 * 接口 精准质检-设置PC质检-次品超期配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/setQualityCpOverdue`
 */
const postSetQualityCpOverdueRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/setQualityCpOverdue",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetQualityCpOverdue",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-设置PC质检-次品超期配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/setQualityCpOverdue`
 */
export const postSetQualityCpOverdue = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetQualityCpOverdueRequestConfig, requestData),
    ...args
  );
};
postSetQualityCpOverdue.requestConfig = postSetQualityCpOverdueRequestConfig;
/**
 * 接口 精准质检-设置PC质检拦截质检配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/setQualityAccurate`
 */
const postSetQualityAccurateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/setQualityAccurate",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetQualityAccurate",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-设置PC质检拦截质检配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/setQualityAccurate`
 */
export const postSetQualityAccurate = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetQualityAccurateRequestConfig, requestData),
    ...args
  );
};
postSetQualityAccurate.requestConfig = postSetQualityAccurateRequestConfig;
/**
 * 接口 脚本配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/getTodayAllotSetting`
 */
const postGetTodayAllotSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/getTodayAllotSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetTodayAllotSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 脚本配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/getTodayAllotSetting`
 */
export const postGetTodayAllotSetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetTodayAllotSettingRequestConfig, requestData),
    ...args
  );
};
postGetTodayAllotSetting.requestConfig = postGetTodayAllotSettingRequestConfig;
/**
 * 接口 获取次日发货设置配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/getMorrowShipments`
 */
const postGetMorrowShipmentsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/getMorrowShipments",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetMorrowShipments",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取次日发货设置配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/getMorrowShipments`
 */
export const postGetMorrowShipments = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetMorrowShipmentsRequestConfig, requestData),
    ...args
  );
};
postGetMorrowShipments.requestConfig = postGetMorrowShipmentsRequestConfig;
/**
 * 接口 设置次日发货设置配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/saveMorrowShipments`
 */
const postSaveMorrowShipmentsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/saveMorrowShipments",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveMorrowShipments",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置次日发货设置配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/saveMorrowShipments`
 */
export const postSaveMorrowShipments = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSaveMorrowShipmentsRequestConfig, requestData),
    ...args
  );
};
postSaveMorrowShipments.requestConfig = postSaveMorrowShipmentsRequestConfig;
/**
 * 接口 高净值用户质检配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/userNetWorthQualityRuleSettingSave`
 */
const postUserNetWorthQualityRuleSettingSaveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/userNetWorthQualityRuleSettingSave",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUserNetWorthQualityRuleSettingSave",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 高净值用户质检配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/AdminSetting/userNetWorthQualityRuleSettingSave`
 */
export const postUserNetWorthQualityRuleSettingSave = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postUserNetWorthQualityRuleSettingSaveRequestConfig, requestData),
    ...args
  );
};
postUserNetWorthQualityRuleSettingSave.requestConfig =
  postUserNetWorthQualityRuleSettingSaveRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 获取来货质检点货配置 的 **请求配置**
 *
 * @分类 旧接口文档/质检改标
 * @请求头 `POST /erp/AdminSetting/getDaBiaoIntercept`
 */
const postGetDaBiaoInterceptRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/AdminSetting/getDaBiaoIntercept",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetDaBiaoIntercept",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取来货质检点货配置 的 **请求函数**
 *
 * @分类 旧接口文档/质检改标
 * @请求头 `POST /erp/AdminSetting/getDaBiaoIntercept`
 */
export const postGetDaBiaoIntercept = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetDaBiaoInterceptRequestConfig, requestData),
    ...args
  );
};
postGetDaBiaoIntercept.requestConfig = postGetDaBiaoInterceptRequestConfig;
/**
 * 接口 保存来货质检配置 的 **请求配置**
 *
 * @分类 旧接口文档/质检改标
 * @请求头 `POST /erp/AdminSetting/setDaBiaoIntercept`
 */
const postSetDaBiaoInterceptRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/AdminSetting/setDaBiaoIntercept",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetDaBiaoIntercept",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存来货质检配置 的 **请求函数**
 *
 * @分类 旧接口文档/质检改标
 * @请求头 `POST /erp/AdminSetting/setDaBiaoIntercept`
 */
export const postSetDaBiaoIntercept = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetDaBiaoInterceptRequestConfig, requestData),
    ...args
  );
};
postSetDaBiaoIntercept.requestConfig = postSetDaBiaoInterceptRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 获取退供单拣货任务拆分优先级配置 的 **请求配置**
 *
 * @分类 旧接口文档/优先级配置
 * @请求头 `POST /erp/AdminSetting/getReturnTaskPriorityInfo`
 */
const postGetReturnTaskPriorityInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/getReturnTaskPriorityInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetReturnTaskPriorityInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取退供单拣货任务拆分优先级配置 的 **请求函数**
 *
 * @分类 旧接口文档/优先级配置
 * @请求头 `POST /erp/AdminSetting/getReturnTaskPriorityInfo`
 */
export const postGetReturnTaskPriorityInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetReturnTaskPriorityInfoRequestConfig, requestData),
    ...args
  );
};
postGetReturnTaskPriorityInfo.requestConfig =
  postGetReturnTaskPriorityInfoRequestConfig;
/**
 * 接口 设置退供单拣货任务拆分优先级配置 的 **请求配置**
 *
 * @分类 旧接口文档/优先级配置
 * @请求头 `POST /erp/AdminSetting/setReturnTaskPriorityInfo`
 */
const postSetReturnTaskPriorityInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/setReturnTaskPriorityInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetReturnTaskPriorityInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置退供单拣货任务拆分优先级配置 的 **请求函数**
 *
 * @分类 旧接口文档/优先级配置
 * @请求头 `POST /erp/AdminSetting/setReturnTaskPriorityInfo`
 */
export const postSetReturnTaskPriorityInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetReturnTaskPriorityInfoRequestConfig, requestData),
    ...args
  );
};
postSetReturnTaskPriorityInfo.requestConfig =
  postSetReturnTaskPriorityInfoRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 获取质检改标配置 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置2
 * @请求头 `GET /erp/AdminSetting/qualityLabelSetting`
 */
const getQualityLabelSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/AdminSetting/qualityLabelSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getQualityLabelSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取质检改标配置 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置2
 * @请求头 `GET /erp/AdminSetting/qualityLabelSetting`
 */
export const getQualityLabelSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getQualityLabelSettingRequestConfig, requestData),
    ...args
  );
};
getQualityLabelSetting.requestConfig = getQualityLabelSettingRequestConfig;
const mockUrl_0_0_0_4 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_4 = "";
const prodUrl_0_0_0_4 = "";
const dataKey_0_0_0_4 = "data";
/**
 * 接口 导入高单价商品数据 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/importHighGoodsNo`
 */
const postImportHighGoodsNoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/importHighGoodsNo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportHighGoodsNo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入高单价商品数据 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/importHighGoodsNo`
 */
export const postImportHighGoodsNo = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postImportHighGoodsNoRequestConfig, requestData),
    ...args
  );
};
postImportHighGoodsNo.requestConfig = postImportHighGoodsNoRequestConfig;
/**
 * 接口 导出高单价商品数据 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/exportHighGoodsNo`
 */
const getExportHighGoodsNoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/exportHighGoodsNo",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getExportHighGoodsNo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出高单价商品数据 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/exportHighGoodsNo`
 */
export const getExportHighGoodsNo = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getExportHighGoodsNoRequestConfig, requestData),
    ...args
  );
};
getExportHighGoodsNo.requestConfig = getExportHighGoodsNoRequestConfig;
/**
 * 接口 获取来货质检点货配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/getDaBiaoIntercept`
 */
const getGetDaBiaoInterceptRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/getDaBiaoIntercept",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetDaBiaoIntercept",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取来货质检点货配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/getDaBiaoIntercept`
 */
export const getGetDaBiaoIntercept = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetDaBiaoInterceptRequestConfig, requestData),
    ...args
  );
};
getGetDaBiaoIntercept.requestConfig = getGetDaBiaoInterceptRequestConfig;
/**
 * 接口 获取PDA拣货路径设置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/getPdaPickRoutes`
 */
const postGetPdaPickRoutesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/getPdaPickRoutes",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPdaPickRoutes",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取PDA拣货路径设置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/getPdaPickRoutes`
 */
export const postGetPdaPickRoutes = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetPdaPickRoutesRequestConfig, requestData),
    ...args
  );
};
postGetPdaPickRoutes.requestConfig = postGetPdaPickRoutesRequestConfig;
/**
 * 接口 设置PDA拣货路径 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setPdaPickRoutes`
 */
const postSetPdaPickRoutesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setPdaPickRoutes",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetPdaPickRoutes",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置PDA拣货路径 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setPdaPickRoutes`
 */
export const postSetPdaPickRoutes = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetPdaPickRoutesRequestConfig, requestData),
    ...args
  );
};
postSetPdaPickRoutes.requestConfig = postSetPdaPickRoutesRequestConfig;
/**
 * 接口 pda相关设置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/pdaSetting`
 */
const getPdaSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/pdaSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getPdaSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 pda相关设置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/pdaSetting`
 */
export const getPdaSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getPdaSettingRequestConfig, requestData), ...args);
};
getPdaSetting.requestConfig = getPdaSettingRequestConfig;
/**
 * 接口 pda相关设置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/pdaSetting`
 */
const postPdaSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/pdaSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPdaSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 pda相关设置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/pdaSetting`
 */
export const postPdaSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postPdaSettingRequestConfig, requestData), ...args);
};
postPdaSetting.requestConfig = postPdaSettingRequestConfig;
/**
 * 接口 获取分播机配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/getCutSetting`
 */
const getGetCutSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/getCutSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetCutSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取分播机配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/getCutSetting`
 */
export const getGetCutSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getGetCutSettingRequestConfig, requestData), ...args);
};
getGetCutSetting.requestConfig = getGetCutSettingRequestConfig;
/**
 * 接口 设置分播机设置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setCutSetting`
 */
const postSetCutSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setCutSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetCutSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置分播机设置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setCutSetting`
 */
export const postSetCutSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSetCutSettingRequestConfig, requestData), ...args);
};
postSetCutSetting.requestConfig = postSetCutSettingRequestConfig;
/**
 * 接口 设置退换货商品不质检配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setQualityRejectHold`
 */
const postSetQualityRejectHoldRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setQualityRejectHold",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetQualityRejectHold",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置退换货商品不质检配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setQualityRejectHold`
 */
export const postSetQualityRejectHold = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetQualityRejectHoldRequestConfig, requestData),
    ...args
  );
};
postSetQualityRejectHold.requestConfig = postSetQualityRejectHoldRequestConfig;
/**
 * 接口 设置PC质检质检时间间隔配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setQualityInterval`
 */
const postSetQualityIntervalRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setQualityInterval",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetQualityInterval",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置PC质检质检时间间隔配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setQualityInterval`
 */
export const postSetQualityInterval = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetQualityIntervalRequestConfig, requestData),
    ...args
  );
};
postSetQualityInterval.requestConfig = postSetQualityIntervalRequestConfig;
/**
 * 接口 获取售后配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/getAfterSaleSetting`
 */
const postGetAfterSaleSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/getAfterSaleSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetAfterSaleSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取售后配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/getAfterSaleSetting`
 */
export const postGetAfterSaleSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetAfterSaleSettingRequestConfig, requestData),
    ...args
  );
};
postGetAfterSaleSetting.requestConfig = postGetAfterSaleSettingRequestConfig;
/**
 * 接口 保存售后配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setAfterSaleSetting`
 */
const postSetAfterSaleSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setAfterSaleSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetAfterSaleSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存售后配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setAfterSaleSetting`
 */
export const postSetAfterSaleSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetAfterSaleSettingRequestConfig, requestData),
    ...args
  );
};
postSetAfterSaleSetting.requestConfig = postSetAfterSaleSettingRequestConfig;
/**
 * 接口 导出售后拦截包裹配置用户id 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/exportAfterSaleUserId`
 */
const postExportAfterSaleUserIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/exportAfterSaleUserId",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportAfterSaleUserId",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出售后拦截包裹配置用户id 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/exportAfterSaleUserId`
 */
export const postExportAfterSaleUserId = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportAfterSaleUserIdRequestConfig, requestData),
    ...args
  );
};
postExportAfterSaleUserId.requestConfig =
  postExportAfterSaleUserIdRequestConfig;
/**
 * 接口 获取退供百分百抵扣商家开关设置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/getRefundCreditSetting`
 */
const getGetRefundCreditSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/getRefundCreditSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetRefundCreditSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取退供百分百抵扣商家开关设置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/getRefundCreditSetting`
 */
export const getGetRefundCreditSetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetRefundCreditSettingRequestConfig, requestData),
    ...args
  );
};
getGetRefundCreditSetting.requestConfig =
  getGetRefundCreditSettingRequestConfig;
/**
 * 接口 设置退供100%抵扣商家设置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setRefundCreditSetting`
 */
const postSetRefundCreditSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setRefundCreditSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetRefundCreditSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置退供100%抵扣商家设置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setRefundCreditSetting`
 */
export const postSetRefundCreditSetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetRefundCreditSettingRequestConfig, requestData),
    ...args
  );
};
postSetRefundCreditSetting.requestConfig =
  postSetRefundCreditSettingRequestConfig;
/**
 * 接口 导入设置百分百抵扣商家ID 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/importRefundCreditSupply`
 */
const postImportRefundCreditSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/importRefundCreditSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportRefundCreditSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入设置百分百抵扣商家ID 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/importRefundCreditSupply`
 */
export const postImportRefundCreditSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportRefundCreditSupplyRequestConfig, requestData),
    ...args
  );
};
postImportRefundCreditSupply.requestConfig =
  postImportRefundCreditSupplyRequestConfig;
/**
 * 接口 导出百分百抵扣的商家ID 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/exportRefundCreditSupply`
 */
const postExportRefundCreditSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/exportRefundCreditSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportRefundCreditSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出百分百抵扣的商家ID 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/exportRefundCreditSupply`
 */
export const postExportRefundCreditSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportRefundCreditSupplyRequestConfig, requestData),
    ...args
  );
};
postExportRefundCreditSupply.requestConfig =
  postExportRefundCreditSupplyRequestConfig;
/**
 * 接口 获取波次分播配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/getCutByWaveSetting`
 */
const getGetCutByWaveSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/getCutByWaveSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetCutByWaveSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取波次分播配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `GET /erp/AdminSetting/getCutByWaveSetting`
 */
export const getGetCutByWaveSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetCutByWaveSettingRequestConfig, requestData),
    ...args
  );
};
getGetCutByWaveSetting.requestConfig = getGetCutByWaveSettingRequestConfig;
/**
 * 接口 设置波次分播配置 的 **请求配置**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setCutByWaveSetting`
 */
const postSetCutByWaveSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setCutByWaveSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetCutByWaveSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置波次分播配置 的 **请求函数**
 *
 * @分类 仓储API/设置
 * @请求头 `POST /erp/AdminSetting/setCutByWaveSetting`
 */
export const postSetCutByWaveSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetCutByWaveSettingRequestConfig, requestData),
    ...args
  );
};
postSetCutByWaveSetting.requestConfig = postSetCutByWaveSettingRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/AdminSetting.js